<template>
  <div>
    <Header />
    <main class="app-content">
      <div class="app-title">
        <div>
          <h1><i class="fa fa-dashboard"></i>MAKİNE GÜNCELLEME EKRANI</h1>
        </div>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
          <li class="breadcrumb-item"><a href="#">MAKİNE GÜNCELLEME EKRANI</a></li>
        </ul>
      </div>
      <div class="row form-margin">
        <div class="col-md-12 tex-center d-flex align-items-center flex-column">
          <div class="tile">
            <h3 class="tile-title">MAKİNE GÜNCELLEME EKRANI</h3>

            <div class="tile-body">
              <form>
                <div class="form-group">
                  <label class="control-label">Makina Adı</label>
                  <span
                    style="background-color: rgb(253, 109, 73);"
                    class="form-control"
                    >{{resultmakine.makina_code + "  " +  resultmakine.makina_name}}</span
                  >
                </div>
                <div><span></span></div>
                <div id="app">
                  <label class="control-label">Kaydedilecek Sahayı Seçiniz</label>
                  <select class="form-control" @change="changesaha($event)">
                    <option value="" selected disabled>SAHA SEÇİNİZ</option>
                    <option v-for="saha in sahalar" :value="saha.id" :key="saha.id">{{ saha.sahaName }}</option>
                  </select>
                </div>
      
                <div id="app">
                  <label class="control-label">1.Operatörü Seçiniz</label>
                  <select class="form-control" @change="changeoprone($event)">
                    <option value="" selected disabled>1.OPERATÖR</option>
                    <option
                      v-for="operator in operators"
                      :value="operator.id"
                      :key="operator.id"
                      >{{ operator.name + " " + operator.surname }}</option
                    >
                  </select>
                </div>
                <div id="app">
                  <label class="control-label">2.Operatörü Seçiniz</label>
                  <select class="form-control" @change="changeoprtwo($event)">
                    <option value="" selected disabled>2.OPERATÖR</option>
                    <option
                      v-for="operator in operators"
                      :value="operator.id"
                      :key="operator.id"
                      >{{ operator.name + " " + operator.surname }}</option
                    >
                  </select>
                </div>
                <div id="app">
                  <label class="control-label"
                    >1.Yardımcı Personeli Seçiniz</label
                  >
                  <select class="form-control" @change="changeyrdone($event)">
                    <option value="" selected disabled
                      >1.YARDIMCI PERSONEL</option
                    >
                    <option
                      v-for="yardimci in yardimcis"
                      :value="yardimci.id"
                      :key="yardimci.id"
                      >{{ yardimci.name + " " + yardimci.surname }}</option
                    >
                  </select>
                </div>
                <div id="app">
                  <label class="control-label"
                    >2.Yardımcı Personeli Seçiniz</label
                  >
                  <select class="form-control" @change="changeyrdtwo($event)">
                    <option value="" selected disabled
                      >2.YARDIMCI PERSONEL</option
                    >
                    <option
                      v-for="yardimci in yardimcis"
                      :value="yardimci.id"
                      :key="yardimci.id"
                      >{{ yardimci.name + " " + yardimci.surname }}</option
                    >
                  </select>
                </div>
              </form>
            </div>

            <div class="tile-footer">
              <button @click="sendData()" class="btn btn-success" type="button">
                <i class="fa fa-fw fa-lg fa-check-circle"></i>Güncelle
              </button>
              <button @click="statusone()" class="btn btn-danger" type="button">
                <i class="fa fa-fw fa-lg fa-check-circle"></i>ASKIYA AL
              </button>
              <button @click="statuszero()" class="btn btn-info" type="button">
                <i class="fa fa-fw fa-lg fa-check-circle"></i>AKTİFLEŞTİR
              </button>
            </div>
          </div>
        </div>
      </div>
    </main>

    <Sidebar />
  </div>
</template>

<script>
import Header from "./default/Header";
import Sidebar from "./default/Sidebar";
import axios from "axios";
import store from "../store";
export default {
  data() {
    return {
      // saha: "",
      makinaId: "",
      oprone: "",
      oprtwo: "",
      yrdone: "",
      yrdtwo: "",
      sahaid: 0,
      machines: [],
      resultmakine: [],
      operators: [],
      yardimcis: [],
      sahalar: [],
      makine_id: this.$route.query.id,
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    var token = localStorage.getItem("token");
    if (!token) {
      this.$router.push("/");
    }

    var datas = {
      makine_id: this.makine_id,
    

    };

    let dataUrl =
      store.state.base_url + "AslanSahalar/getByIdMakine.php?key=123";
    axios.post(dataUrl, JSON.stringify(datas)).then((response) => {
      this.resultmakine = response.data;
    });



    var url = store.state.base_url + "AslanSahalar/getAllSahaDropUpdate.php?key=123";
    axios
      .post(url)
      .then((response) => {
        this.sahalar = response.data;
      })
      .catch((err) => {
        console.log(err.response);
      });
    var url = store.state.base_url + "AslanSahalar/getAllMakina.php?key=123";
    axios
      .post(url)
      .then((response) => {
        this.machines = response.data;
      })
      .catch((err) => {
        console.log(err.response);
      });
    var url = store.state.base_url + "AslanSahalar/getAllOperator.php?key=123";
    axios
      .post(url)
      .then((response) => {
        this.operators = response.data.data;
      })
      .catch((err) => {
        console.log(err.response);
      });
    var url = store.state.base_url + "AslanSahalar/getAllYardimci.php?key=123";
    axios
      .post(url)
      .then((response) => {
        this.yardimcis = response.data.data;
      })
      .catch((err) => {
        console.log(err.response);
      });
  },
  methods: {
    // changesaha(event) {
    //   this.saha = event.target.value;
    // },
    statusone() {
      var dataStatus = {
        id: localStorage.getItem("id"),
        token: localStorage.getItem("token"),
        makine_id: this.makine_id,
      };
      let dataUrl3 =
        store.state.base_url + "AslanSahalar/makinestatusone.php?key=123";
      axios.post(dataUrl3, JSON.stringify(dataStatus)).then((response) => {
        this.$swal({
          text: "MAKİNE BAŞARIYLA KALDIRILDI",
          icon: "success",
          closeOnClickOutside: false,
        });
      });
    },
    statuszero() {
      var dataStatus = {
        id: localStorage.getItem("id"),
        token: localStorage.getItem("token"),
        makine_id: this.makine_id,
      };
      let dataUrl3 =
        store.state.base_url + "AslanSahalar/makinestatuszero.php?key=123";
      axios.post(dataUrl3, JSON.stringify(dataStatus)).then((response) => {
        if (response.data == true) {
          this.$swal({
            text: "MAKİNE BAŞARIYLA GERİ YÜKLENDİ",
            icon: "success",
            closeOnClickOutside: false,
          });
        }
      });
    },
    changeoprone(event) {
      this.oprone = event.target.value;
    },
    changeoprtwo(event) {
      this.oprtwo = event.target.value;
    },
    changeyrdone(event) {
      this.yrdone = event.target.value;
    },
    changeyrdtwo(event) {
      this.yrdtwo = event.target.value;
    },
    changemakina(event) {
      this.makinaId = event.target.value;
    },
    changesaha(event) {
      this.sahaid = event.target.value;
    },
    reload: function() {
      location.reload();
    },
    sendData: function() {
      console.log(this.oprone)
      if (this.oprone == "") {
        this.$swal({
          text: "En az 1 operatör seçiniz!",
          icon: "error",
          closeOnClickOutside: false,
        });
      }else if(this.sahaname == ""){
        this.$swal({
          text: "Saha adı giriniz!",
          icon: "error",
          closeOnClickOutside: false,
        });
      } else {
        var url = store.state.base_url + "AslanSahalar/updateMakine.php?key=123";
        var datas = {
          id: localStorage.getItem("id"),
          token: localStorage.getItem("token"),
          oprone: this.oprone,
          oprtwo: this.oprtwo,
          yrdone: this.yrdone,
          yrdtwo: this.yrdtwo,
          sahaid: this.sahaid,
          makinaId: this.makine_id,
        };

        axios
          .post(url, JSON.stringify(datas))
          .then((response) => {
            if (response.data.data == true) {
              this.$swal({
                text: "Kayıt İşleminiz Başarıyla Gerçekleştirildi!",
                icon: "success",
                closeOnClickOutside: true,
              });
              // setTimeout(function() {location.reload()},1250);

            } else {
              this.$swal({
                text: "Hata Oluştu!",
                icon: "error",
                closeOnClickOutside: false,
              });
            }

            ////conso.log(response);
          })
          .catch((error) => {
            //conso.log(error.response);
          });
      }
    },
  },

  components: {
    Header,
    Sidebar,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/UpdateMakine.vue